module.exports = __webpack_public_path__ + "img/icon_trial_6.72803666.png";